/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: qjs
 * @Date: 2020-05-13 09:24:58
 * @LastEditors: xst
 * @LastEditTime: 2020-05-28 10:49:30
 */
/**
    axios的配置文件
    1、设置post数据格式为表单格式
    2、设置基路径
    3、序列化字符串
*/
import axios from 'axios'
import store from '../vuex'
import router from '../router'
import { MessageBox,Loading } from 'element-ui'
import { message } from '../publicMethods/resetMessage.js'

//配置
//定义loading变量
let loading;
//使用Element loading-start 方法
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中....',
    background: 'rgba(0, 0, 0, 0.02)'
  })
}
//使用Element loading-close 方法
function endLoading() {
  loading.close()
}
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading
let needLoadingRequestCount = 0
//showFullScreenLoading() tryHideFullScreenLoading() 就是将同一时刻的请求合并。
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}
export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
//配置前后端数据交互的请求头：
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 超时配置
axios.defaults.timeout = 30000;
// 设置后台的访问地址
// axios.defaults.baseURL = '地址';
axios.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers = {
        source_menu_key:localStorage.getItem('menu_key')?localStorage.getItem('menu_key'):'',
        accountId:store.state.accountId,
        'Authorization' :`Bearer ${store.state.token}`, //携带权限参数
        withCredentials: true
      };
    }
    showFullScreenLoading();
    // console.log(config,'接口发送对象看看有没有url')
    return config
},
(error) => {
    // return Promise.reject(error);
    return error
});
let i=0;
// respone拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      tryHideFullScreenLoading()
      // 406:Token 过期了;
      if (res.code === 406) {
        if(i==0){//避免弹多个错误弹窗
          i++;
          MessageBox.confirm(res.msg || res.message || '系统异常', '确定登出', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            localStorage.clear();
            sessionStorage.clear();
            i=0;
            // sessionStorage.removeItem('tabnavBox')
            location.reload()
          });
        }


      } else if (res.code === 400) {
        message.error({
          dangerouslyUseHTMLString: true,
          message: res.msg||res.message||'系统异常',
          offset:300 })
        return response
      } else if (res.code === 300) {
        message.error(res.msg || res.message || '系统异常')
        router.push('/page300')
        return response
      } else if (res.code === 504) {
        message.error(res.msg || res.message || '系统异常')
        return response
      } else if (res.type === 'application/vnd.ms-excel') {//导出excel时axios判断
        return response
      } else {
        if (res.msg || res.message) message.error(res.msg || res.message || '系统异常')
        return response
      }
    } else if(res.status == 500) {
      message.error('加载数据失败，请尽快联系管理员！')
      tryHideFullScreenLoading()
      return null
    } else { // res.code === 200,正常返回数据
      tryHideFullScreenLoading()
      return response
    }
  },
  error => {
    console.log(error,'接口发送报错信息')
    if (error && error.toString().indexOf('timeout') !== -1) {
      message.error('请求超时，请重试！')
    } else {
      message.error('系统异常，请联系管理员！')
    }
    tryHideFullScreenLoading()
    return error
  }
)
export default axios;
//在vue主组件中引入即可
// import axios from '@/http/axios'



// WEBPACK FOOTER //
// ./src/publicMethods/axios.js